module.exports = __webpack_public_path__ + "img/detail_link.114cde35.png";